module.exports = {
    login_now: '立即登录 →',
    err_tryagain: '验证码服务器繁忙，请稍后重试(S)',
    input_phone: '请输入手机号码',
    phone_error: '手机号输入错误',
    input_imgcode:'请输入图形验证码',
    imgcode_error: '图形验证码输入错误',
    input_msg: '请输入短信验证码',
    msg_error: '短信验证码输入错误',
    checking: '校验中...',
    msg_sent:'短信验证码已发送',
    imgcode_tips:"图形验证码",
    get_phone_verify : '获取手机验证码',
    get_imgcode:'获取验证码',
    get_imgcode_after: '秒后重新获取',
    phone_verify:'手机短信验证码',
    login_by_phone: '手机验证登录',
    please_select:'请选择',
    cn: '中国(内地)',
    hk: '中国(香港)',
    logout: '退出'
}


// WEBPACK FOOTER //
// ./js/src/i18n/login/cn.js